import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";

import { getEligibility } from "actions/eligibilityActions";
import "styles/SaveDraft.scss";
import MasterButton, { BUTTON_TYPES } from "components/ui/MasterButton";

class SummaryFooter extends Component {
  getUserSubjects = () => {
    const { userRecSubs, userOthSubs, userAddSubs } = this.props;
    const userSubjects = userRecSubs.concat(userOthSubs).concat(userAddSubs);
    return userSubjects;
  };

  handleSubmit = () => {
    const { recommendations_input_hash } = this.props;
    this.props.dispatch(
      getEligibility(this.getUserSubjects(), recommendations_input_hash)
    );
  };

  scrollToProfileSummary = () => {
    const profileSummaryElement = document.getElementById("profile-summary");
    profileSummaryElement.scrollIntoView({ behavior: "smooth" });
  };

  renderDisabledButton = () => (
    <MasterButton
      type={BUTTON_TYPES.PRIMARY}
      disabled={true}
      text="Submit"
      className="footer-button"
    />
  );

  renderSubmitButton = () => (
    <NavLink to={`/${this.props.nextNavlink}`}>
      <MasterButton
        callback={this.handleSubmit}
        type={BUTTON_TYPES.PRIMARY}
        text="Submit"
        className="footer-button"
      />
    </NavLink>
  );

  renderBackButton = () => {
    const { backNavlink } = this.props;
    return (
      <NavLink to={`/${backNavlink}`}>
        <MasterButton
          type={BUTTON_TYPES.SECONDARY}
          text="Back"
          className="footer-button"
          callback={this.handleClickNext}
        />
      </NavLink>
    );
  };

  renderEditButton = () => (
    <MasterButton
      type={BUTTON_TYPES.SECONDARY}
      text="Edit Profile"
      className="footer-button"
      callback={this.scrollToProfileSummary}
    />
  );

  render() {
    const { enable, back, focus } = this.props;
    return (
      <div className={focus ? "hide" : "window-sticky"}>
        <div className="desktop-and-tablet window-sticky-inner">
          {back ? this.renderBackButton() : <div />}
          {enable ? this.renderSubmitButton() : this.renderDisabledButton()}
        </div>

        <div className="mobile-only">
          <div className="window-sticky-inner">
            {back ? this.renderBackButton() : this.renderEditButton()}
            {enable ? this.renderSubmitButton() : this.renderDisabledButton()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = store => {
  // general
  const { email } = store.emailReducer;
  const { input } = store.inputReducer;

  const { userRecSubs } = store.pickRecSubReducer;
  const { userOthSubs } = store.pickOthSubReducer;
  const { userAddSubs } = store.pickAddSubReducer;

  // Recommendations
  const {
    recommendations_input_hash,
    eligibility_input_hash
  } = store.hashReducer;

  return {
    // general
    email,
    input,

    userRecSubs,
    userOthSubs,
    userAddSubs,

    recommendations_input_hash,
    eligibility_input_hash
  };
};
export default connect(mapStateToProps)(SummaryFooter);
